module.exports = __webpack_public_path__ + "img/5-2.7e26ab24.png";